import { CurrencyIcon } from '~/components/collections';
import { useWalletIcon } from '~/hooks';
import { WalletType, walletTypeCurrency } from '~/shared';
import { StyledCurrencyContainer, StyledLabel } from './Currency.styled';

interface CurrencyProps extends React.HTMLAttributes<HTMLDivElement> {
	type: WalletType;
	value: number;
}

const Currency = ({
	type,
	value,
	className,
	children,
	...props
}: CurrencyProps) => {
	const currencyIcon = useWalletIcon(walletTypeCurrency[type], true);

	return (
		<StyledCurrencyContainer
			className={`${className || ''} ${type || ''}`}
			{...props}
		>
			<StyledLabel className="label">
				{value.toLocaleString('ru-RU')}
			</StyledLabel>
			{type && (
				<CurrencyIcon
					icon={currencyIcon}
					size={'md'}
					className={`icon ${type}`}
				/>
			)}
			{children}
		</StyledCurrencyContainer>
	);
};

export { Currency };
